<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 pb-3 font-weight-bold" v-html="title" />
    <div class="col-12 col-md-8 col-xl-9">
      <div class="row pt-2">
        <div class="col-12 col-lg-6">
          <div class="d-flex flex-column align-items-start align-items-xl-start flex-sm-wrap flex-sm-row">
            <button type="button"
              v-for="(item, index) in items.bar"
              :key="'bar-' + index"
              :class="['btn btn-sm btn-outline-filter', filterUiState('supportingStructure', item.value)]"
              v-on:click="selectValue(item.value)">{{ item.title }}</button>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <!-- <span class="d-block pb-2">Brett&shy;stapel&shy;decke, genagelt</span> -->
          <div class="d-flex flex-column align-items-start align-items-xl-start flex-sm-wrap flex-sm-row">
            <button type="button"
              v-for="(item, index) in items.board"
              :key="'board-' + index"
              :class="['btn btn-sm btn-outline-filter', filterUiState('supportingStructure', item.value)]"
              v-on:click="selectValue(item.value)">{{ item.title }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionSupportingStructure',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      title: 'Tragkonstruktion',
      items: {
        bar: [
          { title: 'Balken 220 mm', value: 'b-220' },
          { title: 'Balken 240 mm', value: 'b-240' },
          { title: 'Stegträger 220 mm', value: 'bs-220' }
        ],
        board: [
          // { title: 'Brettstapeldecke, genagelt 120 mm', value: 'bo-120' },
          // { title: 'Brettstapeldecke, genagelt 140 mm', value: 'bo-140' },
          { title: 'Massivholzdecke 120 mm (Steico GLVL)', value: 'mh-120' },
          { title: 'Brettsperrholzdecke 120 mm', value: 'bsh-120' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      let title = ''
      let result = this.items.bar.filter(item => item.value === value)
      if (result.length <= 0) result = this.items.board.filter(item => item.value === value)
      if (result.length > 0) title = result[0].title

      const uiState = this.filterUiState('supportingStructure', value)

      this.$gtm.trackEvent({
        event: 'filter',
        category: this.title,
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: Number(value.split('-')[1])
      })

      this.$store.dispatch('filter/setValue', {
        name: 'supportingStructure',
        title: this.title + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
